import { c as _c } from "react/compiler-runtime";
import { WaveDropIdentity, type WaveDropIdentityVariant } from "@/components/waves/drops/identity/WaveDropIdentity";
import type { ParticipationIdentityProfileCardVariant } from "@/components/waves/drops/participation/ParticipationIdentityProfileCard";
import type { ApiDropMetadataResponse } from "@/generated/models/ApiDropMetadataResponse";
import type { ApiWaveMin } from "@/generated/models/ApiWaveMin";
interface WaveWinnerIdentityProps {
  readonly drop: {
    readonly id?: string | number | undefined;
    readonly wave: Pick<ApiWaveMin, "submission_type"> | null | undefined;
    readonly metadata: readonly ApiDropMetadataResponse[] | null | undefined;
  };
  readonly variant: WaveDropIdentityVariant;
  readonly cardVariant?: ParticipationIdentityProfileCardVariant | undefined;
  readonly className?: string | undefined;
}
export function WaveWinnerIdentity(t0) {
  const $ = _c(5);
  const {
    drop,
    variant,
    cardVariant,
    className
  } = t0;
  let t1;
  if ($[0] !== cardVariant || $[1] !== className || $[2] !== drop || $[3] !== variant) {
    t1 = <WaveDropIdentity drop={drop} variant={variant} cardVariant={cardVariant} className={className} testIdPrefix="wave-winner-identity" />;
    $[0] = cardVariant;
    $[1] = className;
    $[2] = drop;
    $[3] = variant;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}